import axios from 'axios';
import ApiGet from '../sections/mainheader/apiget';

class DataImportService {
    constructor(apiUrl) {
        this.GetApiUrl = apiUrl;

        /**
         * Check if data import is currently running.
         * Calls: GET {apiUrl}Login/GetIsRunningDataImporting
         * Returns: { IsRunningDataImporting: true|false }
         */
        this.GetIsRunningDataImporting = () =>
            axios.get(`${this.GetApiUrl}Login/GetIsRunningDataImporting`);
    }
}

export default ApiGet().then((apiUrl) => new DataImportService(apiUrl));
